module.exports = __webpack_public_path__ + "img/member-12.60aad840.png";